import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type DestinationDetails = { __typename: 'Destination' } & Pick<
  Types.Destination,
  | 'apiToken'
  | 'displayName'
  | 'lastModifiedTime'
  | 'outputId'
  | 'outputType'
  | 'verificationStatus'
  | 'defaultForSeverity'
  | 'alertTypes'
  | 'logTypes'
  | 'allowManualDispatch'
> & {
    outputConfig: {
      asana?: Types.Maybe<
        Pick<Types.AsanaConfig, 'personalAccessToken' | 'projectGids' | 'syncAlertStatus'>
      >;
      blinkOpsWebhook?: Types.Maybe<Pick<Types.BlinkOpsWebhookConfig, 'apiKey' | 'webhookURL'>>;
      customWebhook?: Types.Maybe<
        Pick<Types.CustomWebhookConfig, 'webhookURL'> & {
          customHeaders?: Types.Maybe<
            Array<{ __typename: 'CustomHeader' } & Pick<Types.CustomHeader, 'name' | 'value'>>
          >;
        }
      >;
      expelWebhook?: Types.Maybe<
        Pick<Types.ExpelWebhookConfig, 'webhookURL' | 'webhookUsername' | 'webhookPassword'>
      >;
      gcpPubSub?: Types.Maybe<
        Pick<
          Types.GcpPubSubDestinationConfig,
          'projectId' | 'topicId' | 'credentials' | 'credentialsType'
        >
      >;
      github?: Types.Maybe<Pick<Types.GithubConfig, 'repoName' | 'token'>>;
      incidentIoWebhook?: Types.Maybe<Pick<Types.IncidentIoWebhookConfig, 'apiKey' | 'webhookURL'>>;
      jira?: Types.Maybe<
        Pick<
          Types.JiraConfig,
          | 'orgDomain'
          | 'projectKey'
          | 'userName'
          | 'apiKey'
          | 'assigneeId'
          | 'issueType'
          | 'labels'
          | 'priority'
          | 'pullAlertStatus'
          | 'pullAlertAssignee'
          | 'pullAlertComments'
          | 'syncAlertStatus'
          | 'syncAlertAssignee'
          | 'syncAlertComments'
          | 'useSeverityBasedConfig'
        > & {
          severityBasedConfig?: Types.Maybe<
            Array<
              Types.Maybe<Pick<Types.SeverityBasedJiraConfig, 'severity' | 'labels' | 'priority'>>
            >
          >;
          statusMap?: Types.Maybe<{
            open: Pick<Types.JiraTransitionStatus, 'id' | 'name'>;
            triaged: Pick<Types.JiraTransitionStatus, 'id' | 'name'>;
            resolved: Pick<Types.JiraTransitionStatus, 'id' | 'name'>;
            closed: Pick<Types.JiraTransitionStatus, 'id' | 'name'>;
          }>;
        }
      >;
      jiraDataCenter?: Types.Maybe<
        Pick<
          Types.JiraConfig,
          | 'orgDomain'
          | 'projectKey'
          | 'userName'
          | 'apiKey'
          | 'assigneeName'
          | 'issueType'
          | 'labels'
          | 'priority'
          | 'useSeverityBasedConfig'
        > & {
          severityBasedConfig?: Types.Maybe<
            Array<
              Types.Maybe<Pick<Types.SeverityBasedJiraConfig, 'severity' | 'labels' | 'priority'>>
            >
          >;
        }
      >;
      mindflowWebhook?: Types.Maybe<Pick<Types.MindflowWebhookConfig, 'webhookURL'>>;
      msTeams?: Types.Maybe<Pick<Types.MsTeamsConfig, 'webhookURL'>>;
      opsgenie?: Types.Maybe<Pick<Types.OpsgenieConfig, 'apiKey' | 'serviceRegion'>>;
      pagerDuty?: Types.Maybe<Pick<Types.PagerDutyConfig, 'integrationKey'>>;
      slack?: Types.Maybe<Pick<Types.SlackConfig, 'webhookURL'>>;
      slackBot?: Types.Maybe<
        Pick<
          Types.SlackBotConfig,
          | 'botToken'
          | 'clientId'
          | 'channel'
          | 'clientSecret'
          | 'signingSecret'
          | 'timeLocation'
          | 'syncAlertStatus'
          | 'syncAlertAssignee'
          | 'syncAITriage'
          | 'syncAlertComments'
        >
      >;
      sns?: Types.Maybe<Pick<Types.SnsConfig, 'topicArn'>>;
      splunkWebhook?: Types.Maybe<Pick<Types.SplunkWebhookConfig, 'authToken' | 'webhookURL'>>;
      sqs?: Types.Maybe<Pick<Types.SqsDestinationConfig, 'queueUrl'>>;
      tinesWebhook?: Types.Maybe<Pick<Types.TinesWebhookConfig, 'webhookURL'>>;
      torqWebhook?: Types.Maybe<
        Pick<Types.TorqWebhookConfig, 'webhookURL'> & {
          authenticationHeaders?: Types.Maybe<Array<Pick<Types.CustomHeader, 'name' | 'value'>>>;
        }
      >;
    };
  };

export const DestinationDetails = gql`
  fragment DestinationDetails on Destination {
    apiToken
    displayName
    lastModifiedTime
    outputId
    outputType
    outputConfig {
      asana {
        personalAccessToken
        projectGids
        syncAlertStatus
      }
      blinkOpsWebhook {
        apiKey
        webhookURL
      }
      customWebhook {
        webhookURL
        customHeaders {
          name
          value
          __typename
        }
      }
      expelWebhook {
        webhookURL
        webhookUsername
        webhookPassword
      }
      gcpPubSub {
        projectId
        topicId
        credentials
        credentialsType
      }
      github {
        repoName
        token
      }
      incidentIoWebhook {
        apiKey
        webhookURL
      }
      jira {
        orgDomain
        projectKey
        userName
        apiKey
        assigneeId
        issueType
        labels
        priority
        pullAlertStatus
        pullAlertAssignee
        pullAlertComments
        syncAlertStatus
        syncAlertAssignee
        syncAlertComments
        useSeverityBasedConfig
        severityBasedConfig {
          severity
          labels
          priority
        }
        statusMap {
          open {
            id
            name
          }
          triaged {
            id
            name
          }
          resolved {
            id
            name
          }
          closed {
            id
            name
          }
        }
      }
      jiraDataCenter {
        orgDomain
        projectKey
        userName
        apiKey
        assigneeName
        issueType
        labels
        priority
        useSeverityBasedConfig
        severityBasedConfig {
          severity
          labels
          priority
        }
      }
      mindflowWebhook {
        webhookURL
      }
      msTeams {
        webhookURL
      }
      opsgenie {
        apiKey
        serviceRegion
      }
      pagerDuty {
        integrationKey
      }
      slack {
        webhookURL
      }
      slackBot {
        botToken
        clientId
        channel
        clientSecret
        signingSecret
        timeLocation
        syncAlertStatus
        syncAlertAssignee
        syncAITriage
        syncAlertComments
      }
      sns {
        topicArn
      }
      splunkWebhook {
        authToken
        webhookURL
      }
      sqs {
        queueUrl
      }
      tinesWebhook {
        webhookURL
      }
      torqWebhook {
        webhookURL
        authenticationHeaders {
          name
          value
        }
      }
    }
    verificationStatus
    defaultForSeverity
    alertTypes
    logTypes
    allowManualDispatch
    __typename
  }
`;
